import { getUniqueId } from '@ankr.com/utils/getUniqueId';

export const stakeCacheTags = {
  getBalances: `get-balances-${getUniqueId()}`,
  getStakeGasEstimation: `get-stake-gas-estimation-${getUniqueId()}`,
};
